/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* eslint-disable import/prefer-default-export */
export var STATE_TYPE = {
  change: 'CHANGE'
};
export var ALIGN = {
  vertical: 'vertical',
  horizontal: 'horizontal'
};
/* eslint-enable import/prefer-default-export */